import script from "./ScrapedDataList.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrapedDataList.vue?vue&type=script&setup=true&lang=js"

import "./ScrapedDataList.vue?vue&type=style&index=0&id=6b817d27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b817d27"]])

export default __exports__